import { combineReducers } from 'redux'
import dashboard from './reducers/dashboard'

const rootReducer = combineReducers({
  dashboard,
})

export default rootReducer
